// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import i18n from "./i18n/";

import "./libs/array";
import "./libs/date";

import "./assets/less/base.less";

import "../node_modules/swiper/swiper-bundle.css"; //swiper6.0样式路径
import Swiper, { Navigation, Autoplay, Thumbs } from "swiper"; //相关组件

Swiper.use([Navigation, Autoplay, Thumbs]);

Vue.config.productionTip = false;
Vue.use(ElementUI);

const width = document.documentElement.clientWidth;
if (width < 1000) {
  window.location.href = process.env.VUE_APP_H5_BASE_URL;
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js